import Axios from "../../api/Axios";
const BASE_URL = "PriceList/";
export const Endpoint = {
    GetPriceList : "GetPriceList"
};
// /api/SalesReport/GetGSTToExcel
export const createAPIEndpointPriceList = () => {
    return {get:(Endpoint)=>Axios.get(BASE_URL+Endpoint)};
};